<div class="flex flex-col gap-2">
    @if (label(); as label) {
        <app-label [required]="required()">{{ label }}</app-label>
    }

    <div class="flex gap-2 items-center">
        <label
            class="theme-border"
            [class.active]="value()"
            [attr.data-size]="currentSize()"
        >
            <input
                type="checkbox"
                class="hidden"
                [(ngModel)]="value"
                (change)="handleChange($event)"
                [disabled]="disabled()!"
            />
            <div
                [attr.data-size]="currentSize()"
                class="circle"
                [class.active]="value()"
            ></div>
        </label>
        @if (description(); as description) {
            <p class="text-gray-500 text-sm">{{ description }}</p>
        }
    </div>
</div>
